import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../utils/cn";
import i18n from "../../../i18n";

interface EventTypeSectionProps {
  eventTypes: Array<{
    value: number;
    labelEn: string;
    labelAr: string;
  }>;
  selectedEventType: number | null;
  onToggleEventType: (eventType: number) => void;
  sectionNumber: number;
  disabled?: boolean;
}

const EventTypeSection: React.FC<EventTypeSectionProps> = ({
  eventTypes,
  selectedEventType,
  onToggleEventType,
  sectionNumber,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3">
      <p>
        {t(`${sectionNumber}`)}. {t("eventType")}
      </p>

      <div className="flex flex-wrap items-center gap-3">
        {eventTypes?.map((option) => (
          <div
            key={option.value}
            className={cn(
              "flex items-center gap-2 border rounded-md px-3 py-2 text-[15px] font-normal cursor-pointer",
              selectedEventType === option.value
                ? "bg-purple-primary text-white border-purple-primary"
                : "border-gray-400 bg-gray-100 text-black",
              disabled && "opacity-50 cursor-not-allowed",
            )}
            onClick={() => !disabled && onToggleEventType(option.value)}
          >
            <p>{i18n.language === "en" ? option.labelEn : option.labelAr}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventTypeSection;
